import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import CosmicBackground from '../components/CosmicBackground';

// Mystical Zodiac-Themed Testimonial Component
const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "Abhik Bhattacharya",
      profession: "Engineer, ISRO",
      content: "I was very convinced with the logical ways in which she connected our life events and actions with Astrology and consulted us. Avantika Ji is not only a capable Astrologer who will offer deep and valuable insights about your chart, but also an extremely amiable soul who radiates hope & positivity.",
      image: "/Abhik.png",
      stars: 5,
      zodiacSign: "♐",
      zodiacName: "Sagittarius",
      element: "fire",
      gradient: "from-purple-500 via-pink-500 to-red-500"
    },
    {
      name: "Chandini",
      profession: "Media Professional",
      content: "I consulted Astrohelp to know about my career sometime back. Right help from the right source always works for the better. Thank you for the powerful reading!",
      image: "/client_4.jpg",
      stars: 5,
      zodiacSign: "♌",
      zodiacName: "Leo",
      element: "fire",
      gradient: "from-orange-400 via-red-500 to-yellow-500"
    },
    {
      name: "Gyan",
      profession: "Business Professional", 
      content: "Legal affairs are tricky, but can be dealt with wisdom and patience - I remember this was the exact thing you told me during our interaction. Thank god what you said and evaluated was true.",
      image: "/client_1.jpg",
      stars: 5,
      zodiacSign: "♎",
      zodiacName: "Libra",
      element: "air",
      gradient: "from-blue-300 via-purple-300 to-pink-300"
    },
    {
      name: "Snehil",
      profession: "CEO @ Spotdefence",
      content: "I remember having reached out to you, when I was messing up with my relationship. It became an easy phase, since you made me look into the logics and facts which were so profound and real.",
      image: "/client_2.jpg",
      stars: 5,
      zodiacSign: "♏",
      zodiacName: "Scorpio",
      element: "water",
      gradient: "from-indigo-600 via-purple-600 to-blue-800"
    },
    {
      name: "Shruti",
      profession: "HR Professional",
      content: "I never really believed in astrology, but the work of this young astrologer pushed me far ahead, by revealing facts about myself. Thanks a lot.",
      image: "/client_3.jpg",
      stars: 5,
      zodiacSign: "♍",
      zodiacName: "Virgo",
      element: "earth",
      gradient: "from-green-500 via-emerald-600 to-teal-700"
    },
    {
      name: "Vrica Vij",
      profession: "Counsellor",
      content: "She not only told me confidently about my future occurrences but also gave me a fair assessment of my personality traits that were spot on, which really surprised me.",
      image: "/client_5.jpg",
      stars: 5,
      zodiacSign: "♋",
      zodiacName: "Cancer",
      element: "water",
      gradient: "from-cyan-400 via-blue-500 to-indigo-600"
    },
    {
      name: "Akshay Ray",
      profession: "Corporate Professional, Fiat India",
      content: "The best part about her is that she tries to hear your concerns fully and then guides you in the best path without the use of any costly remedies. Ma'am is surely an example of such guidance!",
      image: "/client_6.jpg",
      stars: 5,
      zodiacSign: "♈",
      zodiacName: "Aries",
      element: "fire",
      gradient: "from-red-500 via-orange-500 to-yellow-400"
    },
    // New testimonials
    {
      name: "Anjana Kumar",
      profession: "Taiwan",
      content: "I consulted Avantika regarding my marriage and compatibility. She is very meticulous and explained every aspect in the horoscope. She is also relatable and helped me understand things in detail as she analyses things closely and from the depth. Her approach towards astrology is very practical. She is very resourceful and has always offered a great astrological guidance.",
      image: "/Anjana.png",
      stars: 5,
      zodiacSign: "♉",
      zodiacName: "Taurus",
      element: "earth",
      gradient: "from-amber-600 via-yellow-700 to-orange-800"
    },
    {
      name: "Sayun Pomoung",
      profession: "PGDA, Archaeological Survey Of India",
      content: "Really loved the consultation with you. It was extremely informative and helpful in the sense of clearing multiple doubts, which I had regarding my career path and moves. Thank you for your clear analysis, wonderful insights and guidance.",
      image: "/Sayun.png",
      stars: 5,
      zodiacSign: "♊",
      zodiacName: "Gemini",
      element: "air",
      gradient: "from-yellow-300 via-green-300 to-blue-300"
    },
    {
      name: "Uma",
      profession: "Doctor, United States",
      content: "I am so happy to find Avantika on Instagram. This was my first time reading with her and I am very happy with my reading. She is very knowledgeable and accurate. She gave me directions and insights I needed to navigate through my uncertainty. She also provided with remedies for my situation. Thank you Avantika!",
      image: "/Uma.png",
      stars: 5,
      zodiacSign: "♒",
      zodiacName: "Aquarius",
      element: "air",
      gradient: "from-teal-400 via-cyan-500 to-blue-600"
    }
  ];

  // Auto-rotate testimonials every 15 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 15000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="max-w-lg mx-auto px-2 sm:px-4">
      <div className="relative">
        
        {/* Simple Rectangular Card - Mobile Optimized */}
        <motion.div
          key={currentIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-2xl p-4 sm:p-6 md:p-8 border border-white/20 hover:border-yellow-400/40 transition-all duration-500"
        >
          {/* Photo on top middle - Mobile Responsive */}
          <div className="text-center mb-4 sm:mb-6">
            <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-3 sm:mb-4 relative">
              <img
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                className="w-full h-full object-cover rounded-full border-2 border-yellow-400/60"
                style={{
                  objectFit: 'cover',
                  objectPosition: 'center center'
                }}
                loading="lazy"
              />
            </div>
            
            <h4 className="text-base sm:text-lg font-bold text-white mb-1">
              {testimonials[currentIndex].name}
            </h4>
            <p className="text-purple-300 text-xs sm:text-sm mb-2 sm:mb-3">
              {testimonials[currentIndex].profession}
            </p>
            
            {/* Stars - Mobile Responsive */}
            <div className="flex justify-center space-x-1 mb-3 sm:mb-4">
              {[...Array(testimonials[currentIndex].stars)].map((_, i) => (
                <span key={i} className="text-yellow-400 text-xs sm:text-sm">⭐</span>
              ))}
            </div>
          </div>

          {/* Content below - Mobile Optimized */}
          <div className="text-center">
            <p className="text-gray-200 text-xs sm:text-sm leading-relaxed px-2 sm:px-0">
              "{testimonials[currentIndex].content}"
            </p>
          </div>
        </motion.div>

        {/* Navigation Buttons - Mobile Optimized */}
        <button
          onClick={prevTestimonial}
          className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-8 sm:-translate-x-12 w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 hover:bg-purple-500 rounded-full flex items-center justify-center text-white transition-all duration-300 opacity-80 hover:opacity-100 touch-manipulation"
          style={{ 
            minWidth: '32px',
            minHeight: '32px',
            WebkitTapHighlightColor: 'transparent'
          }}
          aria-label="Previous testimonial"
        >
          <span className="text-xs sm:text-sm">◀</span>
        </button>
        
        <button
          onClick={nextTestimonial}
          className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-8 sm:translate-x-12 w-8 h-8 sm:w-10 sm:h-10 bg-purple-600 hover:bg-purple-500 rounded-full flex items-center justify-center text-white transition-all duration-300 opacity-80 hover:opacity-100 touch-manipulation"
          style={{ 
            minWidth: '32px',
            minHeight: '32px',
            WebkitTapHighlightColor: 'transparent'
          }}
          aria-label="Next testimonial"
        >
          <span className="text-xs sm:text-sm">▶</span>
        </button>

        {/* Simple Dots */}
        <div className="flex justify-center space-x-2 mt-6">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentIndex 
                  ? 'bg-yellow-400 w-6' 
                  : 'bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);
  const { scrollYProgress } = useScroll();
  const navigate = useNavigate();

  // Simple mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Simple video loading handler
  const handleVideoLoad = () => {
    console.log('Video loaded successfully');
    setVideoLoaded(true);
    setVideoError(false);
  };

  const handleVideoError = (e) => {
    console.log('Video error:', e);
    setVideoError(true);
    setVideoLoaded(false);
  };

  // Minimal parallax transforms - only for desktop
  const y1 = useTransform(scrollYProgress, [0, 1], [0, isMobile ? 0 : -30]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, isMobile ? 0 : -60]);

  return (
    <CosmicBackground>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="min-h-screen"
      >
        {/* Hero Section - Beautiful Video Background Restored */}
        <div className="relative min-h-screen flex items-center justify-center py-20">
          
          {/* Optimized Video Background with Placeholder Image */}
          <div className="absolute inset-0 overflow-hidden">
            {/* Enhanced Placeholder Image - Shows when video is loading or fails */}
            <div 
              className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ${
                videoLoaded && !videoError ? 'opacity-0' : 'opacity-100'
              }`}
              style={{
                backgroundImage: 'url(/HIW-1.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundColor: '#1a1a2e', // Fallback color
              }}
            />
            
            {/* Dark cosmic gradient background fallback */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-indigo-900 to-black opacity-30" />
            
            {/* Video loads on all devices with mobile optimization */}
            <video
                key="hero-video" // Force re-render if needed
                className={`absolute inset-0 w-full h-full object-cover pointer-events-none transition-opacity duration-1000 ${videoLoaded && !videoError ? 'opacity-100' : 'opacity-0'}`}
                style={{
                  objectFit: 'cover',
                  objectPosition: 'center center',
                  willChange: 'transform', // Better performance hint
                }}
                autoPlay={true}
                muted={true}
                loop={true}
                playsInline={true} // Critical for iOS devices
                webkit-playsinline="true" // Legacy iOS support  
                x5-playsinline="true" // Android WeChat compatibility
                preload="metadata" // Consistent preload for all devices
                onLoadedData={handleVideoLoad}
                onError={handleVideoError}
                onLoadStart={() => console.log('Video load started')}
                onCanPlay={() => {
                  console.log('Video can play');
                  if (!videoLoaded) {
                    setVideoLoaded(true);
                  }
                }}
                onCanPlayThrough={() => console.log('Video can play through')}
                onPlay={() => console.log('Video started playing')}
              >
                <source src="/hero-bg.mp4" type="video/mp4" />
                <p>Your browser does not support the video tag.</p>
              </video>
            
            {/* Beautiful overlay for perfect text readability */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
          </div>

          {/* Hero Content - Mobile Optimized */}
          <div className="relative z-20 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            
            {/* Title - Mobile Responsive */}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-300 bg-clip-text text-transparent drop-shadow-lg"
            >
              ✨ Astrohelp ✨
            </motion.h1>
            
            {/* Subtitle - Mobile Responsive */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-gray-200 font-light mb-4 sm:mb-6 drop-shadow-md"
            >
              Your Cosmic Guide to Life's Mystical Journey
            </motion.p>
            
            {/* Description - Mobile Optimized */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed mb-6 sm:mb-8 max-w-2xl mx-auto px-2 sm:px-0 drop-shadow-md"
            >
              Unlock the secrets of the universe with expert Vedic Astrology guidance. 
              Discover your destiny through the ancient wisdom of the stars with{" "}
              <span className="text-yellow-400 font-semibold">Avantika Tripathi</span>.
            </motion.p>

            {/* Stats - Mobile Optimized */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7, duration: 0.8 }}
              className="grid grid-cols-3 gap-4 sm:gap-6 md:gap-8 mb-6 sm:mb-8 max-w-sm sm:max-w-md mx-auto"
            >
              {[
                { number: "25,000+", label: "Consultations" },
                { number: "15+", label: "Years" },
                { number: "100%", label: "Satisfaction" }
              ].map((stat, index) => (
                <div key={index} className="text-center backdrop-blur-sm bg-black/20 rounded-lg p-2 sm:p-3 md:p-4">
                  <div className="text-lg sm:text-xl md:text-2xl font-bold text-yellow-400 drop-shadow-md">{stat.number}</div>
                  <div className="text-xs sm:text-sm md:text-base text-gray-300 drop-shadow-sm">{stat.label}</div>
                </div>
              ))}
            </motion.div>

            {/* CTA Buttons - Fully Mobile Optimized */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.8 }}
              className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-xs sm:max-w-md mx-auto px-2 sm:px-0"
            >
              <motion.button
                onClick={() => navigate('/services')}
                whileHover={!isMobile ? { scale: 1.05 } : {}}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:flex-1 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 touch-manipulation text-sm sm:text-base"
                style={{ 
                  minHeight: '44px',
                  WebkitTapHighlightColor: 'transparent',
                  fontSize: isMobile ? '14px' : '16px'
                }}
              >
                🌟 Explore Services
              </motion.button>
              
              <motion.button
                onClick={() => navigate('/pricing')}
                whileHover={!isMobile ? { scale: 1.05 } : {}}
                whileTap={{ scale: 0.95 }}
                className="w-full sm:flex-1 border-2 border-purple-400 text-purple-200 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold hover:bg-purple-400/20 hover:text-white transition-all duration-300 touch-manipulation backdrop-blur-sm bg-black/10 text-sm sm:text-base"
                style={{ 
                  minHeight: '44px',
                  WebkitTapHighlightColor: 'transparent',
                  fontSize: isMobile ? '14px' : '16px'
                }}
              >
                🔮 Book Consultation
              </motion.button>
            </motion.div>
          </div>
        </div>

        {/* Services Preview Section */}
        <motion.div 
          className="py-20 relative"
          style={{ y: y2 }}
        >
          <div className="max-w-6xl mx-auto px-4">
            
            {/* Section Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-purple-300 to-pink-300 bg-clip-text text-transparent">
                Sacred Celestial Services
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Journey through the cosmos of ancient wisdom and modern insight
              </p>
            </motion.div>
            
            {/* Services Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "🌟 Kundli Dosh Analysis",
                  desc: "Comprehensive cosmic analysis of planetary positions and divine yogas in your birth chart.",
                  color: "from-purple-500 to-indigo-600"
                },
                {
                  title: "📚 Sacred Education Analysis",
                  desc: "Divine educational path guidance based on celestial influences on learning and wisdom.",
                  color: "from-blue-500 to-purple-600"
                },
                {
                  title: "💖 Marriage & Soul Connection",
                  desc: "Sacred compatibility analysis and celestial guidance for harmonious partnerships.",
                  color: "from-pink-500 to-rose-600"
                },
                {
                  title: "🌙 Career & Wealth Guidance",
                  desc: "Divine professional guidance and wealth manifestation based on stellar influences.",
                  color: "from-yellow-500 to-orange-600"
                },
                {
                  title: "🔮 Complete Horoscope Reading",
                  desc: "Complete cosmic life analysis covering health, relationships, career, and finances.",
                  color: "from-indigo-500 to-purple-600"
                },
                {
                  title: "🌠 Cosmic Destiny Reading",
                  desc: "Profound destiny analysis revealing your soul's purpose and divine path.",
                  color: "from-violet-500 to-pink-600"
                }
              ].map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ y: -5 }}
                  className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-2xl p-4 sm:p-6 border border-white/20 hover:border-yellow-400/40 transition-all duration-300"
                >
                  <h3 className="text-base sm:text-lg font-bold mb-2 sm:mb-3 text-white text-center">
                    {service.title}
                  </h3>
                  <p className="text-gray-300 text-xs sm:text-sm text-center leading-relaxed">
                    {service.desc}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Testimonials Section */}
        <motion.div 
          className="py-20 relative"
          style={{ y: y2 }}
        >
          <div className="max-w-6xl mx-auto px-4">
            
            {/* Testimonials Header - Mobile Optimized */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center mb-12 sm:mb-16 px-4"
            >
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-yellow-300 to-yellow-200 bg-clip-text text-transparent">
                What Our Clients Say
              </h2>
              <p className="text-base sm:text-lg text-gray-300 max-w-3xl mx-auto px-2 sm:px-0">
                Real experiences from people who found clarity and direction through cosmic guidance
              </p>
            </motion.div>

            {/* Lightweight Testimonial Carousel */}
            <TestimonialCarousel />

            {/* Stats Section - Mobile Optimized */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 md:gap-8 mt-12 sm:mt-16 px-4"
            >
              {[
                { number: "25,000+", label: "Happy Clients", icon: "👥" },
                { number: "15+", label: "Years Experience", icon: "🌟" },
                { number: "100%", label: "Satisfaction", icon: "💫" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-2xl p-4 sm:p-6 text-center border border-white/20 hover:border-yellow-400/40 transition-all duration-300"
                >
                  <div className="text-2xl sm:text-3xl mb-2 sm:mb-3">{stat.icon}</div>
                  <div className="text-xl sm:text-2xl font-bold text-yellow-400 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-xs sm:text-sm text-white">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </motion.div>
    </CosmicBackground>
  );
};

export default Home;
